import { ServiceClient } from 'src/utils'
import { CompanyRow } from './pj.scopes'

const serviceClient = ServiceClient.singleton()

export class PJService {
    static #INSTANCE = new PJService()
    static readonly singleton = () => PJService.#INSTANCE

    async fetchCompanyInfo(cnpj: string) {
        return serviceClient.authGet<CompanyRow>(`/api/pj/${cnpj}`)
    }
}

export default PJService.singleton()
